import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.min.css'

// Plugins
import vuetify from './plugins/vuetify'
import dotenv from 'dotenv'
import VueGridLayout from 'vue-grid-layout'
import VueApexCharts from 'vue-apexcharts'
import CountryFlag from 'vue-country-flag'
import widgets from '@/components/widgets/widgets'
import DatetimePicker from 'vuetify-datetime-picker'
import { PermissionDirective } from '@/directives/permissionDirective'
import VueGoogleCharts from 'vue-google-charts'

// Styles
import '@mdi/font/css/materialdesignicons.css'
import '@/assets/sass/global.styles.scss'
import VEager from '@kuroski/v-eager'

Vue.use(Vuetify)
Vue.use(VueApexCharts)
Vue.use(DatetimePicker)
Vue.use(VueGoogleCharts)
Vue.directive('permission', PermissionDirective)
Vue.use(VEager)

dotenv.config()

// Global Components
Vue.component('GridLayout', VueGridLayout.GridLayout)
Vue.component('GridItem', VueGridLayout.GridItem)
Vue.component('apexchart', VueApexCharts)
Vue.component('CountryFlag', CountryFlag)

widgets.forEach(w => {
    Vue.component(w.name, w)
})

Vue.directive('$model', {
    /* eslint-disable  @typescript-eslint/no-explicit-any */
    bind: function (el: any, binding: any, vnode: any) {
        el.oninput = () => (vnode.context[binding.expression] = el.value)
    }
})
if (window.location.pathname !== '/') {
    const loader = document.getElementById('initial-loader')
    if (loader) loader.style.display = 'flex'
}
new Vue({
    router,
    store,
    vuetify,
    render: (h) => h(App)
}).$mount('#app')
